import React, { useEffect, useState } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import dlt from '../../utils/default-lang';
import { BodyText, HeadingThree } from '../typography';
import Button from '../ui/button';
import BorrowerOnboardingContentSC, { ContentWrapSC } from './borrower-onboarding-content.styled';
import onBoardingFormData from './borrower-onboarding-proces-data';
import OnboardingCard from './onboarding-card';
import PersonalForm from './personal-form';

import InlineLoading from '../ui/inline-loading';
import WishmakerModal from '../ui/modal/modal';
import ApplicationsSignature from './applications-signature';
import ConsumerSummary from './consumer-summary';
import CreditDocumentation from './credit-documentation';
import FrameworkContract from './framework-contract';
import OnboardingSmsModal from './onboarding-sms-modal';
import SelectInsurance from './select-insurance';
import WageDeduction from './wage-deduction';

const CANCELED_FRAMEWORK_CONTRACT_STATUS = 15;
const CANCELED_PRELOAN_STATUSES = [16, 17];
const WITHDRAWN_STATUSES = [14, 21];
const REJECTED_STATUSES = [8, 14, 15, 16, 17, 21];
const REJECTED_CONTACT_STATUSES = [8, 12];

const _BorrowerOnboardingContent = ({
  getBorrowerOnboardingStep,
  onBoardingStep,
  onBoardingDocuments,
  personalNumber,
  onBoardingStepData,
  sendSms,
  sendBorrowerOnboardingStep,
}) => {
  const cancelRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isServerError, setIsServerError] = useState(false);
  const [isGetStepInterval, setIsGetStepInterval] = useState(false);
  const [onBoardingData, setOnboardingData] = useState(onBoardingFormData);
  /* Modal Data */
  const [isSMSModalOpened, setSMSModalOpened] = useState(false);
  const [additionalModalData, setAdditionalModalData] = useState({});
  const [additionalModalInfo, setAdditionalModalInfo] = useState('');

  /* Steps */
  const personalData = onBoardingData[0];
  const confirmRegistration = onBoardingData[1];
  const frameworkContract = onBoardingData[2];
  const consumerSummary = onBoardingData[3];
  // const identityCard = onBoardingData[4];
  //const signatureConfirm = onBoardingData[16];
  const fillingApplications = onBoardingData[5];
  const applicationsSignature = onBoardingData[6];
  const selectInsurance = onBoardingData[7];
  // const insuranceConfirm = onBoardingData[8];
  const insuranceApplication = onBoardingData[9];
  const awaitingAcceptance = onBoardingData[10];
  const awaitingContractDocumentation = onBoardingData[11];
  const creditDocumentation = onBoardingData[12];
  const insuranceDocumentation = onBoardingData[13];
  const summaryInfo = onBoardingData[14];
  const wageDeduction = onBoardingData[15];
  const finalConfirm = onBoardingData[16];

  const isCanceledFrameworkContractStatus =
    onBoardingStepData?.status === CANCELED_FRAMEWORK_CONTRACT_STATUS;
  const isCanceledPreloanStatus = CANCELED_PRELOAN_STATUSES.includes(
    onBoardingStepData?.status?.id
  );
  const isWithdrawnStatus = WITHDRAWN_STATUSES.includes(onBoardingStepData?.status?.id);
  const isRejectedStatus =
    REJECTED_STATUSES.includes(onBoardingStepData?.status?.id) ||
    REJECTED_CONTACT_STATUSES.includes(onBoardingStepData?.contact_status?.id);

  useEffect(() => {
    getBorrowerOnboardingStep();
  }, [getBorrowerOnboardingStep]);

  /* Check if Data Else Handle Error */
  useEffect(() => {
    const sortOnboardingSteps = () => {
      let newItemId = onBoardingData?.find((item) => item.step === onBoardingStep)?.id;
      let newData = onBoardingData?.map((item) =>
        item.id < newItemId
          ? { ...item, active: true, status: 'done', opened: false, loading: false }
          : item.id === newItemId
          ? { ...item, active: true, status: 'pending', opened: true }
          : item.id > newItemId
          ? { ...item, active: false, status: 'pending', opened: false, loading: false }
          : item
      );
      // eslint-disable-next-line no-lone-blocks
      setOnboardingData(newData);
      setIsGetStepInterval(false);
    };

    if (onBoardingStep !== null && onBoardingStep !== 0) {
      sortOnboardingSteps();
      setIsLoading(false);
      setIsGetStepInterval(false);
    }

    if (onBoardingStep === null) {
      setIsLoading(true);
      setIsGetStepInterval(true);

      cancelRef.current = setTimeout(() => {
        setIsLoading(false);
        setIsGetStepInterval(false);
        setIsServerError(true);
      }, 20 * 1000);
    }

    return () => clearTimeout(cancelRef.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onBoardingStep]);

  useEffect(() => {
    if (fillingApplications.active === true && fillingApplications.status === 'pending') {
      onConfirmationStep(fillingApplications.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fillingApplications.id, fillingApplications.status]);

  useEffect(() => {
    if (summaryInfo.active === true && summaryInfo.status === 'pending') {
      onConfirmationStep(summaryInfo.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summaryInfo.id, summaryInfo.status]);

  /* Get Step Status Every 10 sec. */
  useEffect(() => {
    let interval = '';
    if (isGetStepInterval) {
      interval = setInterval(() => {
        getBorrowerOnboardingStep();
      }, 10000);
    }
    return () => clearInterval(interval);
  }, [isGetStepInterval, getBorrowerOnboardingStep]);

  /* Refresh if Server Error */
  const refreshProcess = () => {
    window.location.reload(false);
  };

  /* Step is Loading */
  const changeLoadingStatus = (itemId, loadingStatus) => {
    const newLoadingData = onBoardingData.map((item) =>
      item.id === itemId ? { ...item, loading: loadingStatus } : item
    );
    setOnboardingData(newLoadingData);
  };

  /* STEP 1 */
  const onPersonalDataConfirm = (formData) => {
    let formattedData = {};
    if (formData.email !== null && formData.email !== '') {
      formattedData = {
        accepted: true,
        wm_number: personalNumber,
        first_name: formData.first_name,
        last_name: formData.last_name,
        personal_identification_number: formData.birth_number.replace('/', ''),
        phone: formData.phone.replace(/ /g, ''),
        email: formData.email,
      };
    } else {
      formattedData = {
        accepted: true,
        wm_number: personalNumber,
        first_name: formData.first_name,
        last_name: formData.last_name,
        personal_identification_number: formData.birth_number.replace('/', ''),
        phone: formData.phone.replace(/ /g, ''),
      };
    }

    setAdditionalModalData(formattedData);
    setAdditionalModalInfo('onboarding_sms_modal_step_two_caution');
    sendSms({ phone: formData.phone.replace(/ /g, '') });
    setSMSModalOpened(true);
  };

  /* Confirmation Steps */
  const onConfirmationStep = (stepId) => {
    setIsGetStepInterval(true);
    changeLoadingStatus(stepId, true);
  };

  /* Simple Confirmation With Sms Steps */
  const onConfirmationWithSmsStep = (additionalInfo) => {
    const formattedData = {
      accepted: true,
    };
    setAdditionalModalInfo(additionalInfo);
    setAdditionalModalData(formattedData);
    sendSms();
    setSMSModalOpened(true);
  };

  const onSelectInsuranceFormSubmit = (formData) => {
    let formattedData = {
      insurance: {
        variant_id: formData.variant,
        questions: formData.questions,
      },
    };

    const onSuccess = () => {
      getBorrowerOnboardingStep();
      changeLoadingStatus(selectInsurance.id, false);
    };

    const onError = () => {};
    const sendRefusedStep = async () => {
      await sendBorrowerOnboardingStep({
        data: formattedData,
        onSuccess,
        onBadSmsCode: () => {},
        onError,
      });
      changeLoadingStatus(selectInsurance.id, true);
    };
    sendRefusedStep();
  };

  /* STEP 7 */
  const onApplicationsSignatureClick = (status) => {
    let formattedData = '';

    if (status === 'declined') {
      formattedData = {
        accepted: false,
      };

      const onSuccess = () => {
        getBorrowerOnboardingStep();
        changeLoadingStatus(applicationsSignature.id, false);
      };

      const onError = () => {};

      const sendRefusedStep = async () => {
        await sendBorrowerOnboardingStep({
          data: formattedData,
          onSuccess,
          onBadSmsCode: () => {},
          onError,
        });
        changeLoadingStatus(applicationsSignature.id, true);
      };
      sendRefusedStep();
    } else {
      formattedData = {
        accepted: true,
      };
      setAdditionalModalInfo('onboarding_sms_modal_step_seven_caution');
      setAdditionalModalData(formattedData);
      sendSms();
      setSMSModalOpened(true);
    }
  };

  /* STEP 11 */
  const onWageDeductionClick = (status) => {
    let formattedData = '';

    if (status === 'declined') {
      formattedData = {
        accepted: false,
      };

      const onSuccess = () => {
        getBorrowerOnboardingStep();
        changeLoadingStatus(wageDeduction.id, false);
      };

      const sendRefusedStep = async () => {
        await sendBorrowerOnboardingStep({
          data: formattedData,
          onSuccess,
          onBadSmsCode: () => {},
          onError: () => {},
        });
        changeLoadingStatus(wageDeduction.id, true);
      };
      sendRefusedStep();
    } else {
      formattedData = {
        accepted: true,
      };
      setAdditionalModalInfo('onboarding_sms_modal_step_eleven_caution');
      setAdditionalModalData(formattedData);
      sendSms();
      setSMSModalOpened(true);
    }
  };

  const onEntryUserAreaClick = () => {
    const onSuccess = () => {
      refreshProcess();
    };

    const sendRefusedStep = async () => {
      await sendBorrowerOnboardingStep({
        data: '',
        onSuccess,
        onBadSmsCode: () => {},
        onError: () => {},
      });
    };
    sendRefusedStep();
  };

  const renderError = React.useMemo(() => {
    if (onBoardingStepData.insurance_contract_canceled_at) {
      return 'insurance_contract_canceled_at';
    } else if (onBoardingStepData.insurance_request_canceled_at) {
      return 'insurance_request_canceled_at';
    }
    return null;
  }, [
    onBoardingStepData.insurance_contract_canceled_at,
    onBoardingStepData.insurance_request_canceled_at,
  ]);

  if (isLoading)
    return (
      <BorrowerOnboardingContentSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </BorrowerOnboardingContentSC>
    );

  if (isServerError)
    return (
      <BorrowerOnboardingContentSC>
        <div className="err-wrap">
          <HeadingThree>Hups</HeadingThree>
          <BodyText className="mid-info-text bolder">
            <FormattedHTMLMessage
              id="error_message_server"
              defaultMessage={dlt['error_message_server']}
            />
          </BodyText>
          <Button type="PRIMARY" onClick={() => refreshProcess()}>
            <FormattedMessage
              id="global_redo_process"
              defaultMessage={dlt['global_redo_process']}
            />
          </Button>
        </div>
      </BorrowerOnboardingContentSC>
    );

  return (
    <BorrowerOnboardingContentSC>
      <WishmakerModal isOpened={isSMSModalOpened} onClose={() => setSMSModalOpened(false)}>
        <OnboardingSmsModal
          additionalData={additionalModalData}
          additionalInfo={additionalModalInfo}
          onClose={() => setSMSModalOpened(false)}
        />
      </WishmakerModal>
      <ContentWrapSC>
        {renderError ? (
          <OnboardingCard
            isRefused
            headline={renderError}
            onRenderAction={() => {}}
            className="completed error"
          />
        ) : null}
        {isRejectedStatus ? (
          <OnboardingCard
            isRefused
            headline={`banner_${onBoardingStepData?.status?.name ??
              onBoardingStepData?.contact_status?.name}`}
            onRenderAction={() => {}}
            className="completed error"
          />
        ) : null}
        {personalData.active ? (
          <OnboardingCard
            status={personalData.status}
            opened={personalData.opened}
            loading={personalData.loading}
            headline="onboarding_personal_headline"
            subtext="onboarding_personal_subtext"
            subtextDone="onboarding_personal_subtext_done"
            personalNumber={personalNumber ? personalNumber : null}
            onRenderAction={() => {}}
          >
            <PersonalForm
              onSubmitForm={(formData) => onPersonalDataConfirm(formData)}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {confirmRegistration.active ? (
          <OnboardingCard
            status={confirmRegistration.status}
            opened={confirmRegistration.opened}
            loading={confirmRegistration.loading}
            headline="onboarding_confirm_registration_headline"
            subtext="onboarding_confirm_registration_subtext"
            subtextDone="onboarding_confirm_registration_subtext_done"
            onRenderAction={
              confirmRegistration.status === 'done'
                ? () => {}
                : () => onConfirmationStep(confirmRegistration.id)
            }
          />
        ) : null}
        {frameworkContract.active ? (
          <OnboardingCard
            status={frameworkContract.status}
            opened={frameworkContract.opened}
            loading={frameworkContract.loading}
            headline="onboarding_framework_contract_headline"
            headlineDone="onboarding_framework_contract_headline_done"
            subtext="onboarding_framework_contract_subtext"
            subtextDone="onboarding_framework_contract_subtext_done"
            onRenderAction={() => {}}
          >
            <FrameworkContract
              onClick={() => onConfirmationWithSmsStep('onboarding_sms_modal_step_three_caution')}
              documents={onBoardingDocuments ? onBoardingDocuments : null}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {consumerSummary.active &&
        !(isCanceledFrameworkContractStatus && consumerSummary.status === 'pending') ? (
          <OnboardingCard
            status={consumerSummary.status}
            opened={consumerSummary.opened}
            loading={consumerSummary.loading}
            headline="onboarding_consumer_summary_headline"
            headlineDone="onboarding_consumer_summary_headline_done"
            subtext="onboarding_consumer_summary_subtext"
            subtextDone="onboarding_consumer_summary_subtext_done"
            onRenderAction={() => {}}
          >
            <ConsumerSummary
              onClick={() => onConfirmationWithSmsStep('onboarding_sms_modal_step_four_caution')}
              documents={onBoardingDocuments ? onBoardingDocuments : null}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {/*   {identityCard.active &&
        !(isCanceledFrameworkContractStatus && identityCard.status === 'pending') ? (
          <OnboardingCard
            status={identityCard.status}
            opened={identityCard.opened}
            loading={identityCard.loading}
            headline="onboarding_identity_card_headline"
            subtext="onboarding_identity_card_subtext"
            subtextDone="onboarding_identity_card_subtext_done"
            onRenderAction={
              identityCard.status === 'done' ? () => {} : () => onConfirmationStep(identityCard.id)
            }
          />
        ) : null} */}
        {fillingApplications.active &&
        !(isCanceledFrameworkContractStatus && fillingApplications.status === 'pending') ? (
          <OnboardingCard
            status={fillingApplications.status}
            opened={fillingApplications.opened}
            loading={fillingApplications.loading}
            headline="onboarding_filling_applications_headline"
            subtext="onboarding_filling_applications_subtext"
            subtextDone="onboarding_filling_applications_subtext_done"
            onRenderAction={
              fillingApplications.status === 'done'
                ? () => {}
                : () => onConfirmationStep(fillingApplications.id)
            }
          />
        ) : null}
        {applicationsSignature.active &&
        !(isCanceledFrameworkContractStatus && applicationsSignature.status === 'pending') ? (
          <OnboardingCard
            status={applicationsSignature.status}
            opened={applicationsSignature.opened}
            loading={applicationsSignature.loading}
            headline="onboarding_applications_signature_headline"
            subtext="onboarding_applications_signature_subtext"
            subtextDone="onboarding_applications_signature_subtext_done"
            onRenderAction={() => {}}
          >
            <ApplicationsSignature
              onClick={(status) => onApplicationsSignatureClick(status)}
              documents={onBoardingDocuments ? onBoardingDocuments : null}
              onBoardingStepData={onBoardingStepData ? onBoardingStepData : null}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {selectInsurance.active ? (
          <OnboardingCard
            status={selectInsurance.status}
            opened={selectInsurance.opened}
            loading={selectInsurance.loading}
            headline="onboarding_select_insurance_headline"
            subtext={
              onBoardingStepData.has_insurance
                ? 'onboarding_select_insurance_subtext_done'
                : 'onboarding_select_insurance_subtext_done_no_insurance'
            }
            onRenderAction={() => {}}
          >
            <SelectInsurance
              insuranceVariants={onBoardingStepData && onBoardingStepData.insurance_variants}
              onBoardingStepData={onBoardingStepData ? onBoardingStepData : null}
              onSubmitForm={(formData) => onSelectInsuranceFormSubmit(formData)}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {isCanceledFrameworkContractStatus ? (
          <OnboardingCard
            isRefused={true}
            status={'done'}
            opened={true}
            loading={false}
            headline="onboarding_framework_contract_canceled_headline"
            subtextDone="onboarding_framework_contract_canceled_subtext"
            onRenderAction={() => {
              setIsGetStepInterval(false);
            }}
            className="refused"
          />
        ) : null}
        {insuranceApplication.active &&
        onBoardingStepData.has_insurance &&
        !(isCanceledFrameworkContractStatus && insuranceApplication.status === 'pending') ? (
          <OnboardingCard
            hasInsurance={onBoardingStepData.has_insurance}
            className={onBoardingStepData.has_insurance ? '' : 'without-insurance'}
            status={insuranceApplication.status}
            opened={insuranceApplication.opened}
            loading={insuranceApplication.loading}
            headline="onboarding_insurance_application_headline"
            headlineDone="onboarding_insurance_application_headline_done"
            subtext="onboarding_insurance_application_subtext"
            subtextDone="onboarding_insurance_application_subtext_done"
            onRenderAction={() => {}}
          >
            <ConsumerSummary
              onClick={() =>
                onConfirmationWithSmsStep('onboarding_sms_modal_step_insurance_application_caution')
              }
              documents={onBoardingDocuments ? onBoardingDocuments : null}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {awaitingAcceptance.active &&
        !(isCanceledFrameworkContractStatus && awaitingAcceptance.status === 'pending') ? (
          <OnboardingCard
            status={awaitingAcceptance.status}
            opened={awaitingAcceptance.opened}
            loading={awaitingAcceptance.loading}
            headline="onboarding_signature_confirm_headline"
            subtext="onboarding_signature_confirm_subtext"
            subtextDone="onboarding_signature_confirm_subtext_done"
            onRenderAction={
              awaitingAcceptance.status === 'done'
                ? () => {}
                : () => onConfirmationStep(awaitingAcceptance.id)
            }
          />
        ) : null}
        {awaitingContractDocumentation.active &&
        !(
          isCanceledFrameworkContractStatus && awaitingContractDocumentation.status === 'pending'
        ) ? (
          <OnboardingCard
            status={awaitingContractDocumentation.status}
            opened={awaitingContractDocumentation.opened}
            loading={awaitingContractDocumentation.loading}
            headline="onboarding_awaiting_contract_documentation_headline"
            subtext="onboarding_awaiting_contract_documentation_subtext"
            subtextDone="onboarding_awaiting_contract_documentation_subtext_done"
            onRenderAction={
              awaitingContractDocumentation.status === 'done'
                ? () => {}
                : () => onConfirmationStep(awaitingContractDocumentation.id)
            }
          />
        ) : null}
        {onBoardingStepData?.status?.id === 8 ? (
          <OnboardingCard
            isRefused={true}
            status={'done'}
            opened={true}
            loading={false}
            headline="onboarding_framework_contract_rejected_headline"
            subtextDone="onboarding_framework_contract_rejected_subtext"
            onRenderAction={() => {
              setIsGetStepInterval(false);
            }}
            className="refused"
          />
        ) : null}
        {isCanceledPreloanStatus ? (
          <OnboardingCard
            isRefused={true}
            status={'done'}
            opened={true}
            loading={false}
            headline="onboarding_contract_draft_canceled_headline"
            subtextDone="onboarding_contract_draft_canceled_subtext"
            onRenderAction={() => {
              setIsGetStepInterval(false);
            }}
            className="refused"
          />
        ) : null}
        {creditDocumentation.active && !isCanceledPreloanStatus ? (
          <OnboardingCard
            status={creditDocumentation.status}
            opened={creditDocumentation.opened}
            loading={creditDocumentation.loading}
            headline="onboarding_credit_documentation_headline"
            subtext="onboarding_credit_documentation_subtext"
            subtextDone="onboarding_credit_documentation_subtext_done"
            onRenderAction={() => {}}
          >
            <CreditDocumentation
              onClick={() => onConfirmationWithSmsStep('onboarding_sms_modal_step_nine_caution')}
              documents={onBoardingDocuments ? onBoardingDocuments : null}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {insuranceDocumentation.active &&
        onBoardingStepData.has_insurance &&
        !(isCanceledFrameworkContractStatus && insuranceDocumentation.status === 'pending') ? (
          <OnboardingCard
            hasInsurance={onBoardingStepData.has_insurance}
            className={onBoardingStepData.has_insurance ? '' : 'without-insurance'}
            status={insuranceDocumentation.status}
            opened={insuranceDocumentation.opened}
            loading={insuranceDocumentation.loading}
            headline="onboarding_insurance_documentation_headline"
            headlineDone="onboarding_insurance_documentation_headline_done"
            subtext="onboarding_insurance_documentation_subtext"
            subtextDone="onboarding_insurance_documentation_subtext_done"
            onRenderAction={() => {}}
          >
            <ConsumerSummary
              onClick={() =>
                onConfirmationWithSmsStep(
                  'onboarding_sms_modal_step_insurance_documentation_caution'
                )
              }
              documents={onBoardingDocuments ? onBoardingDocuments : null}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {summaryInfo.active && !(isWithdrawnStatus && summaryInfo.status === 'pending') ? (
          <OnboardingCard
            status={summaryInfo.status}
            opened={summaryInfo.opened}
            loading={summaryInfo.loading}
            headline="onboarding_summary_info_headline"
            subtext="onboarding_summary_info_subtext"
            subtextDone="onboarding_summary_info_subtext_done"
            onRenderAction={
              summaryInfo.status === 'done' ? () => {} : () => onConfirmationStep(summaryInfo.id)
            }
          />
        ) : null}
        {wageDeduction.active && !(isWithdrawnStatus && wageDeduction.status === 'pending') ? (
          <OnboardingCard
            status={wageDeduction.status}
            opened={wageDeduction.opened}
            loading={wageDeduction.loading}
            headline="onboarding_wage_deduction_headline"
            subtext="onboarding_wage_deduction_subtext"
            subtextDone="onboarding_wage_deduction_subtext_done"
            onRenderAction={() => {}}
          >
            <WageDeduction
              onClick={(status) => onWageDeductionClick(status)}
              documents={onBoardingDocuments ? onBoardingDocuments : null}
              disabled={isRejectedStatus}
            />
          </OnboardingCard>
        ) : null}
        {/*        {signatureConfirm.active &&
        !(onBoardingStepData?.status.id === 8 && signatureConfirm.status === 'pending') ? (
          <OnboardingCard
            status={signatureConfirm.status}
            opened={signatureConfirm.opened}
            loading={signatureConfirm.loading}
            headline="onboarding_signature_confirm_headline"
            subtext="onboarding_signature_confirm_subtext"
            subtextDone="onboarding_signature_confirm_subtext_done"
            onRenderAction={
              signatureConfirm.status === 'done'
                ? () => {}
                : () => onConfirmationStep(signatureConfirm.id)
            }
          />
        ) : null} */}
        {finalConfirm.active && !(isWithdrawnStatus && finalConfirm.status === 'pending') ? (
          <OnboardingCard
            status={finalConfirm.status}
            opened={finalConfirm.opened}
            loading={finalConfirm.loading}
            headlineDone="onboarding_onboarding_final_confirm_headline_done"
            headline="onboarding_onboarding_final_confirm_headline"
            subtextDone="onboarding_onboarding_final_confirm_subtext_done"
            onRenderAction={
              finalConfirm.status === 'done' ? () => {} : () => onConfirmationStep(finalConfirm.id)
            }
            className={finalConfirm.status === 'done' ? 'completed' : null}
          />
        ) : null}
        {isWithdrawnStatus ? (
          <OnboardingCard
            isRefused={true}
            status={'done'}
            opened={true}
            loading={false}
            headline={`onboarding_contract_withdrawn_${
              onBoardingStepData?.status?.id === 14 ? 'by_wm' : 'by_client'
            }_headline`}
            subtextDone={null}
            onRenderAction={() => {
              setIsGetStepInterval(false);
            }}
            className="refused"
          />
        ) : null}
        {renderError ? (
          <OnboardingCard
            isRefused
            headline={renderError}
            onRenderAction={() => {}}
            className="completed error"
          />
        ) : null}
        {isRejectedStatus ? (
          <OnboardingCard
            isRefused
            headline={`banner_${onBoardingStepData?.status?.name ??
              onBoardingStepData?.contact_status?.name}`}
            onRenderAction={() => {}}
            className="completed error"
          />
        ) : null}
      </ContentWrapSC>
      {finalConfirm.status === 'done' && !isWithdrawnStatus ? (
        <div className="final-button-wrap">
          <Button type="PRIMARY" onClick={() => onEntryUserAreaClick()} disabled={isRejectedStatus}>
            <FormattedMessage
              id="onboarding_final_btn_txt"
              defaultMessage={dlt['onboarding_final_btn_txt']}
            />
          </Button>
        </div>
      ) : null}
    </BorrowerOnboardingContentSC>
  );
};

const mapStateToProps = (state) => {
  return {
    onBoardingStep: state.onboarding.step,
    personalNumber: state.user.wm_number,
    onBoardingDocuments: state.onboarding.documents,
    onBoardingStepData: state.onboarding,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getBorrowerOnboardingStep: ActionCreators.getBorrowerOnboardingStep,
      sendSms: ActionCreators.sendSms,
      sendBorrowerOnboardingStep: ActionCreators.sendBorrowerOnboardingStep,
    },
    dispatch
  );
};

const BorrowerOnboardingContent = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_BorrowerOnboardingContent)
);

export default BorrowerOnboardingContent;
